import styled from 'styled-components';

export const StyledInstagram = styled.div``;
